import React from "react";

import FormField from "../../../../../components/form-field/FormField";
import { DynamicProperty } from "../../../../../components/data-components/DynamicProperty";

interface DisplayLabelProps {
  label?: string;
}

interface DisplayMainCodeProps extends DisplayLabelProps {
  mainCode: DynamicProperty | undefined;
}

export function DisplayMainCode(props: DisplayMainCodeProps) {
  return (
    <FormField
      id="main-code"
      labelKey={props.label || "general.damage.main-code"}
      readOnly
      fieldValue={props.mainCode?.value || "-"}
      labelIcon={props.mainCode ? props.mainCode?.getIssueIcon() : undefined}
    />
  );
}

interface DisplayCharacterization1Props extends DisplayLabelProps {
  characterization1: DynamicProperty | undefined;
}

export function DisplayCharacterization1(props: DisplayCharacterization1Props) {
  return (
    <FormField
      id="characterization1"
      labelKey={props.label || "general.damage.characterization1"}
      readOnly
      fieldValue={props.characterization1?.value || "-"}
      labelIcon={props.characterization1 ? props.characterization1?.getIssueIcon() : undefined}
    />
  );
}

interface DisplayCharacterization2Props extends DisplayLabelProps {
  characterization2: DynamicProperty | undefined;
}

export function DisplayCharacterization2(props: DisplayCharacterization2Props) {
  return (
    <FormField
      id="characterization2"
      labelKey={props.label || "general.damage.characterization2"}
      readOnly
      fieldValue={props.characterization2?.value || "-"}
      labelIcon={props.characterization2 ? props.characterization2.getIssueIcon() : undefined}
    />
  );
}
